import { Component, HostBinding, Input, NgModule, OnChanges, OnInit } from '@angular/core';

/**
 * [Spacer Component](https://brightlayer-ui-components.github.io/angular/?path=/info/components-spacer--readme)
 *
 * An invisible utility component that acts as a spacer element in various layouts.
 * It works with flexbox sizing or fixed sizing.
 */
@Component({
    selector: 'ui-spacer',
    template: `
        <ng-content></ng-content>
    `,
    standalone: false,
})
export class SpacerComponent implements OnChanges, OnInit {
    /**
     * Flex grow/shrink value for use in flex layouts
     * @default 1
     */
    @Input() flex = 1;
    /** Height (in px) for static layouts */
    @HostBinding('style.height.px') @Input() height: number;
    /** Width (in px) for static layouts */
    @HostBinding('style.width.px') @Input() width: number;
    @HostBinding('style.flex') grow: string;
    @HostBinding('style.display') display = 'flex';

    /**
     * INFO: add comment
     */
    ngOnInit(): void {
        this.calcGrow();
    }

    /**
     * INFO: add comment
     */
    ngOnChanges(): void {
        this.calcGrow();
    }

    /**
     * INFO: add comment
     */
    calcGrow(): void {
        this.grow = undefined;
        if (!this.height && !this.width) {
            this.grow = `${this.flex} ${this.flex} ${this.flex === 0 ? 'auto' : '0px'}`;
        }
    }
}

/**
 * INFO: add comment
 */
@NgModule({
    declarations: [SpacerComponent],
    exports: [SpacerComponent],
})
export class UiSpacerModule {}
